import React from 'react';
import { Typography } from '@material-ui/core';
import { LoadMoreContainer, StyledReplayIcon } from './LoadMoreCard.styles';

const LoadMoreCard = ({ onClick }: { onClick: () => void }) => {
  return (
    <LoadMoreContainer onClick={onClick}>
      <StyledReplayIcon color="primary" />
      <Typography variant="h5" color="primary">
        Load more
      </Typography>
    </LoadMoreContainer>
  );
};

export default LoadMoreCard;
